import React from "react";
import "../Sitemap.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
    FaHome,
    FaBuilding,
    FaShieldAlt,
    FaCube,
    FaPhoneAlt,
    FaLock,
    FaArrowRight,
    FaSitemap
} from "react-icons/fa";

const sitemapData = [
    {
        title: "Company",
        icon: <FaBuilding />,
        links: [
            { name: "Home", path: "/" },
            { name: "About Us", path: "/about" },
            { name: "Solutions", path: "/solutions" },
            { name: "Products", path: "/products" },
            { name: "Contact", path: "/contact" }
        ]
    },

    {
        title: "Cybersecurity Solutions",
        icon: <FaShieldAlt />,
        links: [
            { name: "Network Security", path: "/solutions" },
            { name: "Cloud Security", path: "/solutions" },
            { name: "Identity & Access Management", path: "/solutions" },
            { name: "Endpoint Protection", path: "/solutions" },
            { name: "Vulnerability Assessment", path: "/solutions" },
            { name: "Security Operations Center", path: "/solutions" },
            { name: "Governance, Risk & Compliance", path: "/solutions" },
            { name: "Incident Response", path: "/solutions" }
        ]
    },

    {
        title: "Products",
        icon: <FaCube />,
        links: [
            {
                name: "BlueLotus SecureShield",
                path: "/bluelotus-secureshield"
            }
        ]
    },

    {
        title: "Legal",
        icon: <FaLock />,
        links: [
            {
                name: "Privacy Policy",
                path: "/privacy-policy"
            },
            {
                name: "Terms & Conditions",
                path: "/terms-conditions"
            },
            {
                name: "Sitemap",
                path: "/sitemap"
            }
        ]
    }
];

const Sitemap = () => {

    return (

        <>

            <Header />

            {/* HERO */}

            <section className="sitemap-hero">

                <div className="container">

                    <motion.div
                        className="hero-content"
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: .8 }}
                    >

                        <span>

                            <FaSitemap />

                            Website Navigation

                        </span>

                        <h1>

                            Sitemap

                        </h1>

                        <p>

                            Easily navigate every page available on the
                            <strong> BlueLotus Infrasafety Projects Private Limited </strong>
                            website. Explore our cybersecurity services,
                            products, company information, legal policies,
                            and contact resources from one convenient location.

                        </p>

                    </motion.div>

                </div>

            </section>

            {/* INTRO */}

            <section className="sitemap-intro">

                <div className="container">

                    <motion.div
                        className="intro-content"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: .8 }}
                    >

                        <span className="section-tag">

                            Website Structure

                        </span>

                        <h2>

                            Find Everything You Need
                            <span> In One Place</span>

                        </h2>

                        <p>

                            Our sitemap provides a complete overview of
                            the BlueLotus website, allowing visitors to
                            quickly access cybersecurity solutions,
                            enterprise products, company information,
                            legal documentation, and support resources.

                        </p>

                    </motion.div>

                </div>

            </section>

            {/* SITEMAP GRID */}

            <section className="sitemap-section">

                <div className="container">

                    <div className="sitemap-grid">

                        {sitemapData.map((section, index) => (

                            <motion.div
                                key={index}
                                className="sitemap-card"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{
                                    duration: .6,
                                    delay: index * .15
                                }}
                            >

                                <div className="card-icon">

                                    {section.icon}

                                </div>

                                <h3>

                                    {section.title}

                                </h3>

                                <ul>

                                    {section.links.map((item, i) => (

                                        <li key={i}>

                                            <a href={item.path}>

                                                {item.name}

                                            </a>

                                        </li>
                                    ))}

                                </ul>

                            </motion.div>

                        ))}

                    </div>

                </div>

            </section>

            {/* QUICK CONTACT */}

          

            {/* CTA */}

          

            <Footer />

        </>

    );

};

export default Sitemap;



